import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useForm, Controller, useFieldArray } from 'react-hook-form';
import '../../App.css';
import { styled } from '../../components/styled';
import SpText from '../../components/atoms/SpText';
import SpButton from '../../components/atoms/SpButton';
import SpTextInput from '../../components/atoms/SpTextInput';
import { SpAutocomplete } from '../../components/atoms/SpAutocomplete';
import { Add, ArrowBack, Close } from '@material-ui/icons';
import ReactPlayer from 'react-player/youtube';
import { Button as MuiButton, Divider, Chip, FormControlLabel, Grid, Radio } from '@material-ui/core';
import { withSnackbar } from '../../components/atoms/SpSnackBar';
import { theme, theme as themeStyle } from '../../components/theme';
import { createTrail, findTrailById, updateTrail } from '../../models/actions/Trails';
import { getAllPointOfInterestsByUser } from '../../models/actions/PointOfInterest';
import { findStationByUserId } from '../../models/actions/Stations';
import { UserSessionContext } from '../../App';

const TitleToolbarSection = styled('div')({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'flex-start'
});

const TrailsDetail = (props) => {
  const [currentTrail, setCurrentTrail] = useState();
  const [currentVideoUrl, setCurrentVideoUrl] = useState(null);
  const [selectedPointOfInterest, setSelectedPointOfInterest] = useState([]);
  const [selectedStationOfUser, setSelectedStationOfUser] = useState(null);
  const [pointOfInterestList, setPointOfInterestList] = useState([]);
  const [stationsOfUser, setStationsOfUser] = useState([]);
  const { trailId } = useParams();
  const history = useHistory();

  const { authData, setAuthData } = useContext(UserSessionContext);

  const { register, control, getValues, handleSubmit, reset, setValue } = useForm({
    shouldUnregister: false,
    name: 'station'
  });

  const fetchData = async () => {
    try {
      let response;
      const userData = authData.userId;
      if (userData) {
        const usersStations = await findStationByUserId({ id_user: userData }, authData.accessToken);
        usersStations && setStationsOfUser(usersStations);
      }
      if (trailId) {
        response = await findTrailById({ id_trail: trailId }, authData.accessToken);
        if (response) {
          setCurrentVideoUrl(response.video_url);
          setSelectedStationOfUser(response.station);
          reset({ ...response });
        }
      }
      if (response?.point_of_interests.length > 0) {
        setSelectedPointOfInterest(response?.point_of_interests);
      }
      //get
      const responsePOI = await getAllPointOfInterestsByUser({ id_user: authData.userId }, authData.accessToken);
      if (responsePOI) {
        setPointOfInterestList([...responsePOI]);
      }
    } catch (error) {
      props.snackbarShowErrorMessage(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const saveTrail = async () => {
    try {
      props.isLoading(true);
      if (trailId) {
        const response = await updateTrail({ trail: { ...getValues(), id: trailId, id_user: authData.userId, id_station: selectedStationOfUser.id, point_of_interests: selectedPointOfInterest } }, authData.accessToken);
        if (response) {
          setCurrentTrail(response);
          props.snackbarShowMessage(response.message);
        }
      } else {
        const response = await createTrail({ trail: { ...getValues(), id_user: authData.userId, id_station: selectedStationOfUser.id, point_of_interests: selectedPointOfInterest } }, authData.accessToken);
        response && history.push('/trails');
      }
      props.isLoading(false);
    } catch (error) {
      props.isLoading(false);
      props.snackbarShowErrorMessage(error);
    }
  };

  const formControlStyleCheck = { width: 30, color: 'black' };
  const formControlStyleInput = { width: '100%', marginTop: '1%' };

  return (
    <>
      <Grid
        style={{ paddingLeft: '1%' }}
        direction="column"
        container
        spacing={2}
      >
        <Grid
          item
          container
          xs={12}
          justifyContent="space-between"
        >
          <Grid
            item
            xs={8}
          >
            <TitleToolbarSection>
              <ArrowBack
                onClick={() => history.push('/trails')}
                style={{ width: 25, color: themeStyle.colors.mainGreen.secondary, height: 50, cursor: 'pointer' }}
              />
              <SpText
                variant="breadcrumbs"
                style={{ marginRight: '5px' }}
              >
                {trailId ? `Home / Percorsi / ` : `Home / Percorsi `}
              </SpText>
              <SpText variant="breadcrumbsSelected">{getValues('title') && trailId ? getValues('title') : currentTrail?.name}</SpText>
            </TitleToolbarSection>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          container
          spacing={3}
          direction="column"
          style={{ backgroundColor: 'rgb(77, 172, 39,0.7)' }}
        >
          <Grid
            item
            xs={12}
            style={{ display: 'flex', justifyContent: 'flex-end' }}
          >
            {trailId ? (
              <Grid
                item
                xs={3}
              >
                <SpButton
                  buttonType="accept"
                  text={'Modifica'}
                  style={{ width: '100%' }}
                  variant="h1PageTitle"
                  onClick={handleSubmit(saveTrail)}
                />
              </Grid>
            ) : (
              <Grid
                item
                xs={3}
              >
                <SpButton
                  buttonType="accept"
                  text={'Salva'}
                  style={{ width: '100%' }}
                  ariant="h1PageTitle"
                  onClick={handleSubmit(saveTrail)}
                />
              </Grid>
            )}
          </Grid>
          <Grid
            item
            xs={12}
            container
            direction="column"
          >
            <form>
              <Grid
                item
                xs={12}
              >
                <SpTextInput
                  label="Nome"
                  labelColor={'black'}
                  type="string"
                  formControlStyle={formControlStyleInput}
                  variant="inputLabel"
                  inputRef={register}
                  name="title"
                />
                <SpTextInput
                  label="Durata Previta (Ore)"
                  labelColor={'black'}
                  type="number"
                  formControlStyle={formControlStyleInput}
                  variant="inputLabel"
                  inputRef={register}
                  name="duration"
                />
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <SpAutocomplete
                    label={'Scegli dei punti di interesse per costruire il percorso'}
                    multiple
                    formControlWidth={'100%'}
                    formControlStyle={{ marginTop: 15 }}
                    labelPaddingTop={'0'}
                    value={selectedPointOfInterest}
                    onChange={(_, value) => setSelectedPointOfInterest(value)}
                    options={pointOfInterestList}
                    getOptionLabel={(elem) => elem.title ?? ''}
                    getOptionSelected={(option, value) => option.id === value?.id}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          style={{ backgroundColor: theme.colors.mainGreen.secondary, color: 'white', border: `1px solid ${theme.colors.mainGreen.secondary}` }}
                          label={option.title}
                          size="medium"
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                  />
                  <SpAutocomplete
                    getOptionSelected={(option, value) => option.id === value?.id}
                    getOptionLabel={(elem) => elem.name ?? ''}
                    label={'Scegli la stazione alla quale associare il percorso'}
                    formControlWidth={'100%'}
                    formControlStyle={{ marginTop: 15 }}
                    labelPaddingTop={'0'}
                    value={selectedStationOfUser}
                    onChange={(_, value) => setSelectedStationOfUser(value)}
                    options={stationsOfUser}
                  />
                </div>

                <SpTextInput
                  label="Inserisci il link del video (Da youtube)"
                  labelColor={'black'}
                  type="string"
                  formControlStyle={formControlStyleInput}
                  variant="inputLabel"
                  inputRef={register}
                  name="video_url"
                  onChange={(e) => setCurrentVideoUrl(e.target.value)}
                />
              </Grid>
            </form>
          </Grid>
          <Grid
            item
            xs={12}
          >
            <SpText
              variant="formText"
              style={{ marginTop: 10 }}
            >
              Anteprima video
            </SpText>
            <ReactPlayer
              style={{ border: '1px solid', borderColor: theme.colors.mainGreen }}
              url={currentVideoUrl}
              config={{
                youtube: {
                  playerVars: { showinfo: 1 }
                },
                facebook: {
                  appId: '12345'
                }
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default withSnackbar(TrailsDetail);
